/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {settleTransactionExternally} from '../api'

export const useMutationSettleTransactionExternally = createReactQueryMutationHook('settleTransactionExternally', settleTransactionExternally)
